<div class="availability-container">
  <div class="header">
    <h2>Disponibilidad</h2>
    <div class="date-navigation">
      <button class="nav-btn" (click)="navigateWeek(-1)">&lt;</button>
      <span class="date-range">{{ currentWeek }}</span>
      <button class="nav-btn" (click)="navigateWeek(1)">&gt;</button>
    </div>
  </div>

  <div class="content">
    <!-- Sección de Fecha -->
    <div class="section">
      <h3>Fecha</h3>
      <div class="date-grid">
        <div *ngFor="let item of dateItems" class="date-item" [class.selected]="item.selected" (click)="selectDate(item)">
          <span class="day">{{ item.day }}</span>
          <span class="date">{{ item.date.toString().padStart(2, '0') }}</span>
        </div>
      </div>
    </div>

    <!-- Sección de Horario -->
    <div class="section">
      <h3>Horario</h3>
      <div class="time-header">
        <div class="selected-date">Seleccionado: {{ selectedDate }}</div>
        <div class="time-navigation">
          <button class="nav-btn" (click)="navigateDay(-1)" [disabled]="!canNavigateToPreviousDay()" [class.disabled]="!canNavigateToPreviousDay()" title="Día anterior">&lt;</button>
          <button class="nav-btn" (click)="navigateDay(1)" [disabled]="!canNavigateToNextDay()" [class.disabled]="!canNavigateToNextDay()" title="Día siguiente">&gt;</button>
        </div>
      </div>
      <div class="time-period-tabs">
        <button *ngFor="let period of periods" class="tab-btn" [class.active]="period === selectedPeriod" (click)="selectPeriod(period)">
          {{ period }}
        </button>
      </div>
      <div class="time-slots">
        <button *ngFor="let time of getCurrentTimeSlots()" class="time-slot" [class.selected]="isTimeSelected(time)" [disabled]="isTimeDisabled(time)" (click)="toggleTimeSlot(time)">
          {{ time | timeFormat }}
        </button>
      </div>
    </div>

    <!-- Resumen de la semana -->
    <div class="section">
      <h3>Resumen de la semana</h3>
      <div *ngFor="let summary of weekSummary" class="summary-item">
        <span class="summary-day">{{ summary.day | dateFormat }}:</span>
        <div class="summary-times">
          <span *ngFor="let time of summary.times" class="time-tag">{{ time | timeFormat }}</span>
        </div>
      </div>
      <!-- {{ summaryData | json }} -->

    </div>
  </div>
  <div class="footer">
    <button class="save-btn" (click)="saveAvailability()">Guardar disponibilidad</button>

  </div>


</div>